module.exports = __webpack_public_path__ + "static/media/arrowtwo.f4ebbea8.svg";